module.exports = __webpack_public_path__ + "assets/img/car16.3c130a80.jpg";